import React from "react";
import { useTranslation } from "react-i18next";
import { useCurrentPortfolio } from "../../../../store";
import { SGridContainer, SAssetsHeader, SGridRow1, SGridRow2 } from "./styles";
import { PortfolioEditorAssetItem } from "../PortfolioEditorAssetItem/PortfolioEditorAssetItem";

export const PortfolioEditorAssetsList: React.FC = () => {
  const { t } = useTranslation();
  const { selectedPortfolio } = useCurrentPortfolio();
  const assetsLength =
    selectedPortfolio && Object.keys(selectedPortfolio.assets).length;
  const isPlural = assetsLength !== 1;

  return (
    <SGridContainer>
      <SGridRow1>
        <SAssetsHeader>
          {assetsLength}{" "}
          {isPlural ? t("editorList.asset_plural") : t("editorList.asset")}{" "}
          {isPlural
            ? t("editorList.selected_plural")
            : t("editorList.selected")}
        </SAssetsHeader>
      </SGridRow1>
      <SGridRow2>
        {selectedPortfolio &&
          Object.keys(selectedPortfolio.assets).map((assetKey) => (
            <PortfolioEditorAssetItem
              key={assetKey}
              assetKey={assetKey}
              asset={selectedPortfolio.assets[assetKey]}
            />
          ))}
      </SGridRow2>
    </SGridContainer>
  );
};
